"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapClientState = void 0;
var browser_client_1 = require("@speechly/browser-client");
var types_1 = require("./types");
function mapClientState(s) {
    switch (s) {
        case browser_client_1.ClientState.Failed:
            return types_1.SpeechState.Failed;
        case browser_client_1.ClientState.NoBrowserSupport:
            return types_1.SpeechState.NoBrowserSupport;
        case browser_client_1.ClientState.NoAudioConsent:
            return types_1.SpeechState.NoAudioConsent;
        case browser_client_1.ClientState.Disconnecting:
        case browser_client_1.ClientState.Disconnected:
            return types_1.SpeechState.Idle;
        case browser_client_1.ClientState.Connecting:
            return types_1.SpeechState.Connecting;
        case browser_client_1.ClientState.Connected:
            return types_1.SpeechState.Ready;
        case browser_client_1.ClientState.Starting:
        case browser_client_1.ClientState.Recording:
            return types_1.SpeechState.Recording;
        case browser_client_1.ClientState.Stopping:
            return types_1.SpeechState.Loading;
        default:
            return types_1.SpeechState.Failed;
    }
}
exports.mapClientState = mapClientState;
//# sourceMappingURL=state.js.map